module.exports = __webpack_public_path__ + "static/media/atrium-7.1a725f82.jpg";